<template>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb mb-0">
            <!-- Skeleton placeholdery - only shown during initial load -->
            <li
                v-if="loading && isInitialLoad"
                v-for="n in placeholderCount"
                :key="n"
                class="breadcrumb-item skeleton-tag"
            ></li>

            <!-- During subsequent loads, show the existing items with a loading style -->
            <li
                v-else-if="loading && !isInitialLoad && items.length > 0"
                v-for="(crumb, i) in items"
                :key="`loading-${i}`"
                :class="['breadcrumb-item', { active: i === items.length - 1 }, 'opacity-50']"
                :aria-current="i === items.length - 1 ? 'page' : null"
            >
                <a v-if="i < items.length - 1" :href="crumb.url">{{ crumb.label }}</a>
                <span v-else>{{ crumb.label }}</span>
            </li>

            <!-- Skutečné položky when not loading -->
            <li
                v-else
                v-for="(crumb, i) in items"
                :key="`breadcrumb-${i}`"
                :class="['breadcrumb-item', { active: i === items.length - 1 }]"
                :aria-current="i === items.length - 1 ? 'page' : null"
            >
                <a v-if="i < items.length - 1" :href="crumb.url">{{ crumb.label }}</a>
                <span v-else>{{ crumb.label }}</span>
            </li>
        </ol>
    </nav>
</template>

<script setup>
import { defineProps } from 'vue'

const props = defineProps({
    /** položky breadcrumbů */
    items: {
        type: Array,
        required: true,
    },
    /** zda se momentálně načítá (zobrazí skeleton) */
    loading: {
        type: Boolean,
        default: false,
    },
    /** zda jde o první načtení komponenty */
    isInitialLoad: {
        type: Boolean,
        default: false,
    },
    /** počet skeleton položek */
    placeholderCount: {
        type: Number,
        default: 3,
    },
})
</script>

<style scoped>
.skeleton-tag {
    display: inline-block;
    width: 80px;
    height: 1rem;
    background-color: #f0f0f0;
    border-radius: 4px;
    margin-right: 0.5rem;
}

/* Remove divider for skeleton breadcrumb items */
.breadcrumb .breadcrumb-item.skeleton-tag + .breadcrumb-item.skeleton-tag:before {
    content: none;
    display: none;
}
</style>
